export const GET_SETTINGS = 'GET_SETTINGS';
export const GET_SETTINGS_SUCCESS = 'GET_SETTINGS_SUCCESS';
export const GET_SETTINGS_ERROR = 'GET_SETTINGS_ERROR';
export const POST_SETTINGS = 'POST_SETTINGS';
export const POST_SETTINGS_SUCCESS = 'POST_SETTINGS_SUCCESS';
export const POST_SETTINGS_ERROR = 'POST_SETTINGS_ERROR';
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';
export const POST_SESSIONS_PRIVACY = 'POST_SESSIONS_PRIVACY';
export const POST_SESSIONS_PRIVACY_SUCCESS = 'POST_SESSIONS_PRIVACY_SUCCESS';
export const POST_SESSIONS_PRIVACY_ERROR = 'POST_SESSIONS_PRIVACY_ERROR';

export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';

export const NOTIFICATION_TYPE = {
    SUCCESS: 'success',
    ERROR: 'error'
};

export const SET_CURRENT_VIEW = 'SET_CURRENT_VIEW';

export const LOGOUT = 'LOGOUT';



// WEBPACK FOOTER //
// ./src/UserSettings/actions/constants.js